import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import useFairDetails from './fair-details.hook';
import FairForm from './components/fair-form';

export default function FairDetails() {
  const {
    isEdit,
    loadingFairDetails,
    methods,
    control,
    isSubmitting,
    STATUS_LABEL,
    STATUS_OPTIONS,
    onSubmit,
    navigate,
  } = useFairDetails();
  return (
    <Page title={isEdit ? 'Editar Feira' : 'Cadastrar Feira'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading={isEdit ? 'Editar Feira' : 'Cadastrar Feira'} links={[]} />
        {loadingFairDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <FairForm
            methods={methods}
            control={control}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
            statusOptions={STATUS_OPTIONS}
            statuslabel={STATUS_LABEL}
            onSubmit={onSubmit}
            navigate={navigate}
          />
        )}
      </Container>
    </Page>
  );
}
